import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import qs from 'qs';

import { getUrlAccessToken, isAuthEnabled } from '../auth/config';
import { getAccessToken } from '../auth/token';
import LocalStorageService from '../services/localStorage';

import { apiErrorHandler } from './error-handler';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const baseURL = process.env.REACT_APP_MYPOLICIES_API_URL;

const api = axios.create({
  baseURL,
  headers,
  paramsSerializer: (params) =>
    qs.stringify(params, { arrayFormat: 'comma', skipNulls: true }),
  timeout: 30000,
  validateStatus(status) {
    return status >= 200 && status < 300;
  },
});

api.interceptors.request.use(async (config) => {
  const urlAccessToken = getUrlAccessToken();

  if (urlAccessToken) {
    config.params = { ...config.params, access_token: urlAccessToken };
  } else if (isAuthEnabled && !config.headers['no-auth']) {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  const legacyToken = LocalStorageService.getToken();
  if (legacyToken) {
    config.headers.token = legacyToken;
  }

  return config;
});

api.interceptors.response.use((response) => {
  if (response.data) {
    return response.data;
  }
  return response;
}, apiErrorHandler);

const apiGet = <T>(url: string, config?: AxiosRequestConfig) =>
  api.get<T, T>(url, config);

const apiPost = <T>(url: string, data?: unknown, config?: AxiosRequestConfig) =>
  api.post<T, T>(url, data, config);

export { api, apiGet, apiPost };
